export const gtag = {
  UploadImage: '이미지 업로드',
  UploadLib: '내 이미지',
};
